import React from 'react'
import './Header.css'

const Header = () => {
  return (
    <header className="header" role="banner">
      <div className="container">
        <div className="header-content">
          <div className="logo-section">
            <div className="logo">
              <span className="logo-icon">📱</span>
              <div className="logo-text">
                <h1 className="logo-title">QRGenerator</h1>
                <p className="logo-subtitle">Powered by Sutralink</p>
              </div>
            </div>
          </div>
          
          <nav className="nav" role="navigation" aria-label="Main navigation">
            <ul className="nav-list">
              <li className="nav-item">
                <a href="#generator" className="nav-link">
                  <span className="nav-icon">🎯</span>
                  Generator
                </a>
              </li>
              <li className="nav-item">
                <a href="#features" className="nav-link">
                  <span className="nav-icon">✨</span>
                  Features
                </a>
              </li>
              <li className="nav-item">
                <a href="#about" className="nav-link">
                  <span className="nav-icon">ℹ️</span>
                  About
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  )
}

export default Header 